// @flow
import { useIntl } from 'react-intl';
import { isObject } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const useFormattedFieldErrors = (errors: string | Array<string> | Object | null): string | null => {
    const { formatMessage } = useIntl();


    if (!errors) {
        return null;
    }

    if (Array.isArray(errors)) {
        return errors.join(' ');
    }

    if (typeof errors === 'object' && isObject(errors)) {
        return errors.defaultMessage ? formatMessage(errors) : null;
    }

    return String(errors);
};
